import getIn from 'immutable-less/transmute/getIn';
import Action from 'automation-ui-action-features/records/Action';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as messageActions from 'automation-ui-canvas/actions/MessageActions';
import { PASTE_SUCCESS, SAVED_WORKFLOW_FAILED } from 'automation-ui-canvas/constants/AlertTypes';
import { fetchClonedCustomCodeActions } from 'automation-ui-canvas/data/api/cloneActionApis';
import { hydrateMetadata } from 'automation-ui-action-features/actions/ActionMetadataConfigUtils';
import * as placements from 'automation-ui-canvas/components/canvas/copyPaste/placements';
import { LOCAL_STORAGE_COPIED_ACTION_KEY } from 'automation-ui-canvas/components/canvas/copyPaste/localStorageKeys';
import { getEdgeIdForAction } from 'automation-ui-canvas/utils/getEdgeIdForAction';
import { setActionTypeId } from 'automation-ui-action-features/actions/custom-code/utils/setActionTypeId';
export const hydrateAction = action => {
  return hydrateMetadata({
    action
  }).then(hydratedAction => {
    if (hydratedAction.getActionTypeId() && hydratedAction.getActionType() === ActionTypes.CUSTOM_CODE) {
      const originalActionTypeId = hydratedAction.getActionTypeId();
      return fetchClonedCustomCodeActions([originalActionTypeId]).then(({
        results
      }) => {
        const newActionTypeId = getIn([0, action.getActionTypeId(), 'actionTypeId'], results);
        return setActionTypeId(newActionTypeId, hydratedAction);
      });
    }
    return Promise.resolve(hydratedAction);
  });
};
export function prepareActionForInsertion({
  flow,
  newAction
}) {
  const updatedAction = newAction.clearMetadata();
  return updatedAction.setActionId(flow.getNextAvailableActionId());
}
export function getEdgeId(placement, flow, actionId, parentBranchIndex) {
  return placement === placements.BEFORE ? flow.getParentEdges({
    //Casting there is safe because you can never insert before a virtual actions
    actionId: actionId,
    includeGoToEdges: false
  })[0].edgeId : getEdgeIdForAction(actionId, parentBranchIndex);
}
export function mergeCopiedActionIntoFlow({
  baseActionId,
  branches,
  branchIndexToSetDownstreamActionsIn,
  defaultBranchName,
  deleteDownstreamActions,
  edgeId,
  flow,
  newAction,
  placement,
  parentBranchIndex
}) {
  const insertedEdgeId = edgeId && !placement && !baseActionId ? edgeId : getEdgeId(placement, flow, baseActionId, parentBranchIndex);
  return flow.getSanitizedFlow().insertAction({
    action: newAction,
    edgeId: insertedEdgeId,
    branchIndexToSetDownstreamActionsIn,
    branches,
    defaultBranchName,
    deleteDownstreamActions
  });
}
export function savePaste({
  updateFlow,
  flow
}) {
  return updateFlow({
    flow,
    sourceApp: 'WORKFLOWS_APP'
  });
}
export function insertAndUpdateFlowWithLocallyStoredAction({
  baseActionId,
  branches,
  branchIndexToSetDownstreamActionsIn,
  defaultBranchName,
  deleteDownstreamActions,
  dispatch,
  edgeId,
  flow,
  parentBranchIndex,
  placement,
  updateFlow,
  onSaveCallback = () => {}
}) {
  let copiedData;
  try {
    const rawData = localStorage.getItem(LOCAL_STORAGE_COPIED_ACTION_KEY);
    copiedData = JSON.parse(rawData || '');
  } catch (error) {
    return new Promise(() => error);
  }
  let action = new Action(copiedData.action);
  return hydrateAction(action).then(hydratedAction => {
    action = hydratedAction;
    const newAction = prepareActionForInsertion({
      flow,
      newAction: action
    });
    const updatedFlow = mergeCopiedActionIntoFlow({
      baseActionId,
      branches,
      branchIndexToSetDownstreamActionsIn,
      defaultBranchName,
      deleteDownstreamActions,
      edgeId,
      flow,
      newAction,
      parentBranchIndex,
      placement
    });
    return savePaste({
      updateFlow,
      flow: updatedFlow
    }).then(() => {
      dispatch(messageActions.addAlert(PASTE_SUCCESS));
    }).then(() => {
      onSaveCallback();
    });
  }).catch(() => {
    dispatch(messageActions.addAlert(SAVED_WORKFLOW_FAILED));
  });
}